import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { FaroTableColumnVisibilityMenu } from "@components/common/faro-table/faro-table-column-visibility-menu";
import { PROJECTS_SORT_BY_MAP } from "@components/projects/projects-sort-constants";
import { PROJECTS_TABLE_COLUMN_LABELS } from "@components/table/projects/projects-table-constants";
import { getSortByFromGridSortModel } from "@components/table/projects/projects-table-utils";
import { useProjectsTableColumns } from "@components/table/projects/use-projects-table-columns";
import { useProjectsTableContext } from "@components/table/projects/use-projects-table-context";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useHandleColumnOrderChange } from "@hooks/use-handle-column-order-change";
import { useProjectsPageBulkActions } from "@pages/projects/use-projects-page-bulk-actions";
import { API_PROJECTS_PER_REQUEST } from "@store/projects/projects-slice-utils";
import { ProjectEvents, TableType } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback } from "react";
/**
 * Listing all the projects of a subject such as a company or a group in a table
 */
export function ProjectsTable(t0) {
  const $ = _c(40);
  const {
    companyId,
    projects,
    isLoading,
    groupId,
    projectArchivingState,
    nextPageCursor,
    loadMoreProjects,
    sortBy,
    setSortBy,
    totalCount
  } = t0;
  const {
    navigateToProjectDetail
  } = useAppNavigation();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== groupId || $[1] !== projectArchivingState) {
    t1 = {
      projectArchivingState,
      groupId
    };
    $[0] = groupId;
    $[1] = projectArchivingState;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const contextType = useProjectsTableContext(t1);
  let t2;
  if ($[3] !== companyId || $[4] !== contextType) {
    t2 = {
      companyId,
      contextType
    };
    $[3] = companyId;
    $[4] = contextType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const columns = useProjectsTableColumns(t2);
  const t3 = PROJECTS_SORT_BY_MAP[sortBy];
  let t4;
  if ($[6] !== t3) {
    t4 = [t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const sortModel = t4;
  let t5;
  if ($[8] !== setSortBy) {
    t5 = newModel => {
      const newSortBy = getSortByFromGridSortModel(newModel);
      setSortBy(newSortBy);
    };
    $[8] = setSortBy;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleSortModelChange = t5;
  let t6;
  if ($[10] !== companyId || $[11] !== contextType || $[12] !== navigateToProjectDetail || $[13] !== trackEvent) {
    t6 = project => {
      trackEvent({
        name: ProjectEvents.openProjectDetails,
        props: {
          projectId: project.id,
          eventLocation: contextType,
          viewMode: "list"
        }
      });
      navigateToProjectDetail({
        companyId,
        projectId: project.id
      });
    };
    $[10] = companyId;
    $[11] = contextType;
    $[12] = navigateToProjectDetail;
    $[13] = trackEvent;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleRowClick = t6;
  let t7;
  if ($[15] !== loadMoreProjects) {
    t7 = async () => await loadMoreProjects();
    $[15] = loadMoreProjects;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const handleLoadMoreProjects = t7;
  const t8 = contextType === "group projects" ? "group" : "workspace";
  let t9;
  if ($[17] !== companyId || $[18] !== projectArchivingState || $[19] !== projects || $[20] !== t8) {
    t9 = {
      companyId,
      projects,
      projectStatus: projectArchivingState,
      subjectType: t8
    };
    $[17] = companyId;
    $[18] = projectArchivingState;
    $[19] = projects;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const actionButtons = useProjectsPageBulkActions(t9);
  let tableTypeEnum;
  if (contextType === "active projects") {
    tableTypeEnum = TableType.activeProjects;
  } else {
    if (contextType === "archived projects") {
      tableTypeEnum = TableType.archiveProjects;
    } else {
      tableTypeEnum = TableType.groupProjects;
    }
  }
  const handleColumnOrderChange = useHandleColumnOrderChange(tableTypeEnum);
  const t10 = !!nextPageCursor;
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = ["name"];
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== tableTypeEnum) {
    t12 = <FaroTableColumnVisibilityMenu labelsMap={PROJECTS_TABLE_COLUMN_LABELS} disabledColumns={t11} tableType={tableTypeEnum} />;
    $[23] = tableTypeEnum;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      "& .MuiDataGrid-row": {
        cursor: "pointer"
      },
      "& .MuiDataGrid-columnHeader:hover .drag-handle": {
        display: "flex"
      },
      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        width: "100%"
      }
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== actionButtons || $[27] !== columns || $[28] !== handleColumnOrderChange || $[29] !== handleLoadMoreProjects || $[30] !== handleRowClick || $[31] !== handleSortModelChange || $[32] !== isLoading || $[33] !== projects || $[34] !== sortModel || $[35] !== t10 || $[36] !== t12 || $[37] !== tableTypeEnum || $[38] !== totalCount) {
    t14 = <FaroTable entities={projects} uniqueIdKey="id" isLoading={isLoading} columns={columns} onRowClick={handleRowClick} rowHeight={70} bulkActionButtons={actionButtons} pageSize={API_PROJECTS_PER_REQUEST} onNextPage={handleLoadMoreProjects} hasMoreItems={t10} totalCount={totalCount} tableType={tableTypeEnum} onSortModelChange={handleSortModelChange} sortTrackingSubject="Projects" sortModel={sortModel} paginationMode="server" filterMenuTrigger={t12} onColumnOrderChange={handleColumnOrderChange} sx={t13} />;
    $[26] = actionButtons;
    $[27] = columns;
    $[28] = handleColumnOrderChange;
    $[29] = handleLoadMoreProjects;
    $[30] = handleRowClick;
    $[31] = handleSortModelChange;
    $[32] = isLoading;
    $[33] = projects;
    $[34] = sortModel;
    $[35] = t10;
    $[36] = t12;
    $[37] = tableTypeEnum;
    $[38] = totalCount;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
}